<template>
    <section class="section px-4 py-4">
        <div class="pb-4">
            <p v-t="'project.settings.notifications_area_description'" />
            <hr class="mb-4" />
        </div>
        <div class="columns is-mobile">
            <div class="column">
                <p
                    v-t="`project.settings.email_notifications`"
                    class="title is-6"
                ></p>
            </div>

            <div class="column is-2 has-text-right">
                <label class="switch">
                    <input v-model="isWatchingProject" type="checkbox" />
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
        <div v-if="showElements">
            <section @click="activeDropdown = undefined" class="px-0 py-0">
                <div
                    v-for="(value, option) in configuration"
                    :key="option"
                    class=""
                >
                    <div class="columns is-mobile is-vcentered">
                        <div class="column pr-0">
                            <p
                                v-t="`project.settings.${option}`"
                                class="title is-size-6 mb-0"
                            ></p>
                            <p
                                v-t="`project.settings.${option}_desc`"
                                class="is-size-7"
                            ></p>
                        </div>

                        <div class="column is-4 has-text-right pl-0">
                            <label
                                v-if="typeof value === 'boolean'"
                                class="switch"
                            >
                                <input
                                    v-model="activeConfiguration[option]"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <div
                                v-else
                                :class="{
                                    'is-active': option == activeDropdown,
                                }"
                                class="dropdown is-up is-right"
                            >
                                <div
                                    class="dropdown-trigger"
                                    @click.stop="activeDropdown = option"
                                >
                                    <button
                                        class="button"
                                        aria-haspopup="true"
                                        aria-controls="dropdown-menu"
                                    >
                                        <span>{{
                                            $t(
                                                `Constants.${activeConfiguration[option]}`
                                            ) || $t('Buttons.select')
                                        }}</span>
                                        <span class="icon is-small">
                                            <i
                                                class="fas fa-angle-up"
                                                aria-hidden="true"
                                            ></i>
                                        </span>
                                    </button>
                                </div>
                                <div
                                    id="dropdown-menu"
                                    class="dropdown-menu"
                                    role="menu"
                                >
                                    <div class="dropdown-content">
                                        <a
                                            v-t="`Constants.${constant}`"
                                            v-for="constant in value"
                                            :key="constant"
                                            class="
                                                dropdown-item
                                                is-size-6
                                                has-text-black
                                            "
                                            @click="
                                                activeConfiguration[option] =
                                                    constant
                                            "
                                        >
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </section>
</template>

<script>
import _ from 'underscore';
export default {
    data() {
        return {
            activeDropdown: undefined,
            configuration: {
                new_object: true,
                new_comment: true,
                mentions: true,
                thread_comments: true,
                report_frequency: ['NONE', '1D', '3D', '1W', '1M'],
            },
            activeConfiguration: {},
            defaultConfiguration: {
                new_object: true,
                new_comment: true,
                mentions: true,
                thread_comments: true,
                report_frequency: 'NONE',
            },
            showElements: false,
        };
    },
    computed: {
        projectConfiguration() {
            if (!this.$store.getters.project.userConfiguration) {
                return this.defaultConfiguration;
            }
            return JSON.parse(
                JSON.stringify(this.$store.getters.project.userConfiguration)
            );
        },
        isWatchingProject: {
            get() {
                if (!this.$store.getters.project.watching) {
                    // console.log('not watched');
                    this.$store.getters.project.watching = false;
                }
                // console.log('iswatching', this.$store.getters.project.watching);
                return this.$store.getters.project.watching;
            },
            set(newValue) {
                // console.log('setting watching', newValue);
                const projectId = this.$store.getters.project._id;
                // console.log(this.$store.getters.project);
                if (newValue) {
                    this.$store.dispatch('startWatchingProject', projectId);
                    this.showElements = true;
                } else {
                    this.$store.dispatch('stopWatchingProject', projectId);
                    this.showElements = false;
                }
            },
        },
    },
    watch: {
        activeConfiguration: {
            deep: true,
            handler() {
                // console.log('handling');
                this.$emit('update', this.activeConfiguration);
            },
        },
    },
    beforeMount() {
        this.activeConfiguration = _.extend(
            this.defaultConfiguration,
            this.projectConfiguration.mailing
        );
    },
    methods: {},
};
</script>

<style></style>
